<template>
    <div class="publicWelfare" style="overflow-y: scroll;overflow-x: scroll;">
        <div style="padding: 20px;">
            <h1>法律筹-公益援助审核</h1>
            <table>
                <thead>
                <tr><th>标题</th> <th>姓名</th> <th>所属类型</th> <th>地址</th> <th>案情介绍</th><th>审核</th></tr>
                </thead>
                <tbody>
                    <tr v-for="(value,index) in listData">
                        <td>{{value.aidTitle}}</td>
                        <td>{{value.aidName}}</td>
                        <td>{{value.cname}}</td>
                        <td>{{value.pname}}-{{value.cityName}}</td>
                        <td>{{value.aidContent}}</td>
                        <td>
                            <Button type="primary" shape="circle" @click="toExamine(value.aidId,value.ischeck)" style="margin-right: 5px">通过</Button>
                            <Button shape="circle" @click="toExamine1(value.aidId,value.ischeck)">不通过</Button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!---->
            <h1>法律筹-公益评论审核</h1>
            <table>
                <thead>
                <tr><th>评论援助标题</th> <th>评论人姓名</th> <th>评论内容</th> <th>审核</th></tr>
                </thead>
                <tbody>
                <tr v-for="(value,index) in listData1">
                    <td>{{value.aidTitle}}</td>
                    <td>{{value.nickname}}</td>
                    <td>{{value.content}}</td>
                    <td>
                        <Button type="primary" shape="circle" @click="comment(value.commentId,value.isCheck)" style="margin-right: 5px">通过</Button>
                        <Button shape="circle" @click="toExamine2(value.commentId,value.isCheck)" >不通过</Button>
                    </td>
                </tr>
                </tbody>
            </table>
            <!---->
            <h1>公益法律服务联盟 已有{{mu}}家</h1>
            <table>
                <thead>
                <tr><th>申请名称(律所/律师)</th> <th>联系人姓名</th> <th>联系电话</th> <th>联系邮箱</th><th>联系地址</th><th>时间</th></tr>
                </thead>
                <tbody>
                <tr v-for="(value,index) in listData2">
                    <td>{{index+1}}：{{value.orgname}}</td>
                    <td>{{value.linkname}}</td>
                    <td>{{value.linktel}}</td>
                    <td>{{value.linkemail}}</td>
                    <td>{{value.orgname}}</td>
                    <td>{{value.time}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "publicWelfare",
        data () {
            return {
                listData : [],
                listData1 : [],
                pageSize : '20',
                page : '1',
                userId : '1',
                page1 : '1',
                listData2 : [],
                mu : '',
            }
        },
        methods :{
            ShowCrowdAidCheck : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/ShowCrowdAidCheck',
                    data: {page:_this.page, userId:_this.userId,pageSize :_this.pageSize,},
                    success: function (res) {
                        if(res.status == false){
                            _this.listData = []
                        }else {
                            _this.listData = res.data.List
                        }

                    }
                })
            },
            toExamine : function (aidId,ischeck) {
                console.log(aidId)
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/CheckCrowdAid',
                    data: {aidId:aidId,userId:_this.userId,ischeck:1},
                    success: function (res) {
                        _this.isCheckCommentList()
                    }
                })
            },
        //    评论
            isCheckCommentList : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/isCheckCommentList',
                    data: {page:_this.page, userId:_this.userId,pageSize :_this.pageSize,},
                    success: function (res) {
                        if(res.status == false){
                            _this.listData1 = []
                        }else {
                            _this.listData1 = res.data.List
                        }

                    }
                })
            },
            comment : function (commentId,isCheck) {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/checkAidComment',
                    data: {userId :_this.userId,commentId:commentId,ischeck:1,},
                    success: function (res) {
                        _this.isCheckCommentList()
                        console.log(res)

                    }
                })
            },
            toExamine1 : function (aidId,ischeck) {
                console.log(aidId)
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/CheckCrowdAid',
                    data: {aidId:aidId,userId:_this.userId,ischeck:2},
                    success: function (res) {
                        _this.isCheckCommentList()
                    }
                })
            },
            toExamine2 : function (commentId,isCheck) {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/checkAidComment',
                    data: {userId :_this.userId,commentId:commentId,ischeck:2,},
                    success: function (res) {
                        _this.isCheckCommentList()
                        console.log(res)

                    }
                })
            },
            orgList : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/orgList',
                    data: {key: "", page: _this.page1, pageSize: "200"},
                    success: function (res) {
                        console.log(res)
                        _this.listData2 = res.data
                    }
                })
            },
            orgCount : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/orgCount',
                    data: {},
                    success: function (res) {
                        console.log(res)
                        _this.mu = res.data
                    }
                })
            }
        },
        mounted () {
            this.ShowCrowdAidCheck()
            this.isCheckCommentList()
            this.orgList()
            this.orgCount()
        }
    }
</script>

<style scoped>
    .publicWelfare table {
        font-family: Consolas,Menlo,Courier,monospace;
        font-size: 12px;
        border-collapse: collapse;
        border-spacing: 0;
        empty-cells: show;
        border: 1px solid #e9e9e9;
        width: 100%;
        margin-bottom: 24px;
    }
    .publicWelfare table th {
        background: #f7f7f7;
        white-space: nowrap;
        color: #5c6b77;
        font-weight: 600;
    }
    .publicWelfare table td, .publicWelfare table th {
        border: 1px solid #e9e9e9;
        padding: 8px 16px;
        text-align: left;
    }
</style>
